@if (selectedNotification) {
  <div class="notification-item">
    <h4>
      <span class="title">{{currentLang == 'fr' ? selectedNotification.TitleFr : selectedNotification.Title}}</span><br>
      <!-- <span class="time">
      {{selectedNotification.CreatedDate | utcToLocalDateTime : 'EEEE, MMMM dd, yyyy' : currentLang == 'en' ? 'en-CA' : 'fr-CA'}}
      {{'General.At' | translate }}
      {{selectedNotification.CreatedDate | utcToLocalDateTime : 'hh:mm a'}}
    </span> -->
  </h4>
  <div class="content rich-text-render" [innerHTML]="trustHtml(selectedNotification.NotificationNote)"></div>
  @if (showCourseDetails) {
    <div>
      <!--  Training Program details -->
      <div>
        <h4 class="section-header">
          {{'CreateClassroom.TrainingProgramDetails' | translate}}
        </h4>
      </div>
      <div class="content">
        <label class="field">{{'Marketplace.TrainingProgram' | translate}}</label>
        <label class="answer-text">
          {{currentLang == 'en' ? courseDetails.ProgramFullName : courseDetails.ProgramFullNameFr}}
        </label>
        <label class="field">
          {{'Marketplace.TrainingType' | translate}}
        </label>
        <label class="answer-text">
          {{currentLang == 'en' ? courseDetails.TrainingTypeName : courseDetails.TrainingTypeNameFr}}
        </label>
        <label class="field">
          {{'SafetyAndPrevention.Language' | translate}}
        </label>
        <label class="answer-text">
          {{(!courseDetails.IsFrench ? 'SafetyAndPrevention.English' : 'SafetyAndPrevention.French') | translate}}
        </label>
      </div>
      <!--  Training Date and Time -->
      <div>
        <h4 class="section-header">{{'CreateClassroom.TrainingDateandTime' | translate}}</h4>
      </div>
      <div class="content">
        <label class="field">
          {{'OnboardingSummary.Date' | translate}}
        </label>
        <label class="answer-text">{{courseDetails.ClassTimes[0].ClassDate | date}}</label>
        <ng-container>
          <div class="inline-block ontario-margin-right-24-!">
            <label class="field">{{'CreateClassroom.FromTime' | translate}}</label>
            <label class="answer-text">{{ getLocalTimeString(courseDetails.ClassTimes[0].ClassDate!.toString())}}</label>
          </div>
          <div class="inline-block">
            <label class="field">{{'CreateClassroom.ToTime' | translate}}</label>
            <label class="answer-text">{{ getLocalTimeString(courseDetails.ClassTimes[0].EndDate!.toString())}}</label>
          </div>
        </ng-container>
      </div>
      <!--  Training location -->
      <div>
        <h4 class="section-header">{{'CreateClassroom.TrainingLocation' | translate}}</h4>
      </div>
      <div class="content">
        <label class="field">{{'Address.StreetAddress' | translate}}</label>
        <label class="answer-text margin-bottom-0">
          @if (courseDetails.AptSuiteUnit) {
            <span>{{courseDetails.AptSuiteUnit}} - </span>
            }{{courseDetails.AddressLine}}
          </label>
          <label class="field">{{'Address.CityTown' | translate}}</label>
          <label class="answer-text">{{courseDetails.CityTown}}</label>
          <label class="field">{{'Address.Province' | translate}}</label>
          <label class="answer-text">{{courseDetails.Province}}</label>
          <label class="field">{{'Address.PostalCode' | translate}}</label>
          <label class="answer-text">{{courseDetails.PostalCode | postalCode}}</label>
        </div>
        <!--  Contact Information-->
        <div>
          <h4 class="section-header">{{'TrainingProviderContactUs.ContactUs' | translate}}</h4>
        </div>
        <div class="content">
          <label class="field">{{'Contact.Email' | translate}}</label>
          <label class="answer-text">{{formatUtil.replaceEmptyWithNA(courseDetails.Email?.ElectronicAddressValue)}}</label>
          <label class="field">{{'Contact.Phone' | translate}}</label>
          <label class="answer-text">
            {{formatUtil.replaceEmptyWithNA(courseDetails.PhoneNumber?.ElectronicAddressValue) | phone}}
          </label>
          <label class="field">{{'CreateClassroom.Website' | translate}}</label>
          <label class="answer-text">
            @if (!courseDetails.Website?.ElectronicAddressValue) {
              <span>N/A</span>
            }
            @if (courseDetails.Website?.ElectronicAddressValue) {
              <a target="_blank"
                [href]="formatUtil.formatExternalLink(courseDetails.Website?.ElectronicAddressValue!)">
                {{courseDetails.Website?.ElectronicAddressValue}}
                <img class="ext-link" src="assets/images/external-link-blue.svg" alt-text="external link" aria-label="external-link">
              </a>
            }
          </label>
        </div>
      </div>
    }
  </div>
}
